// Replaces all sequences of whitespace in a string with a single space and trims leading/trailing whitespace.
// Returns an empty string if the input is not a string.
export const normalizeWhitespace = str => (typeof str === "string" ? str.replace(/\s+/g, " ").trim() : "");